/* Kuk sepet (sop/sepet-checkout.json 1-14). Çekmece ve /cart aynı betiği kullanır.
   Çekmece: başlıktaki sepet ikonu ve ürün sayfasındaki SEPETE EKLE açar; sağdan 200 ms; X, Esc, arka plan, 'Alışverişe
   devam et' ve Android geri tuşu (tek geçmiş kaydı) kapatır. Satır: adet (/cart/change.js), sil (5 sn 'Geri al'),
   stok ve ağ hataları. 'Bununla iyi gider' tek dokunuşla ekler. Hediye notu ve kurumsal fatura 500 ms sonra sepet
   özelliği olarak kaydedilir (/cart/update.js); ödemeye geçerken form da gönderir. VKN 10 hane değilse ve sözleşme
   onayı (kutu modu) yoksa ÖDEMEYE GEÇ pasif görünür, dokununca hata yazar. Politika bağlantıları alt sayfada açılır.
   Değişiklikte yalnız sepet parçaları (data-sepet-parca) ve başlık sayacı Section Rendering API ile yeniden çizilir.
   Dinlenen olay: 'kuk:sepete-eklendi' (assets/kuk-urun.js). Yayılan: 'kuk:olay' (add_to_cart, remove_from_cart,
   begin_checkout). */
(() => {
  if (customElements.get('kuk-sepet')) return;
  const { azHareket, kaydirma, doldur, olay, kilit, altSayfa } = window.kukOrtak;
  const BASLIK = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const bekle = (ms) => new Promise((coz) => { setTimeout(coz, ms); });
  const emoji = /\p{Extended_Pictographic}/u;
  const dokunmatik = () => window.matchMedia('(pointer: coarse)').matches;
  const secici = (anahtar) => `[data-anahtar="${CSS.escape(anahtar)}"]`;

  class KukSepet extends HTMLElement {
    connectedCallback() {
      if (this.hazir) return;
      this.hazir = true;
      this.cekmece = this.dataset.baglam === 'cekmece';
      this.panel = this.querySelector('[data-sepet-panel]');
      this.govde = this.querySelector('[data-sepet-govde]');
      this.form = this.querySelector('[data-sepet-form]');
      this.kayitlar = {};
      if (this.form) {
        this.form.noValidate = true;
        this.form.addEventListener('submit', (e) => this.gonder(e));
        this.form.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && e.target.matches('input:not([type="checkbox"])')) { e.preventDefault(); e.target.blur(); }
        });
      }
      this.addEventListener('click', (e) => this.tikla(e));
      this.addEventListener('input', (e) => this.girdi(e));
      this.addEventListener('change', (e) => this.degisti(e));
      this.addEventListener('focusin', (e) => this.klavye(e, true));
      this.addEventListener('focusout', (e) => this.klavye(e, false));
      this.govde?.addEventListener('scroll', () => this.eklendiKaldir(false), { passive: true });
      document.addEventListener('click', (e) => this.ikonaTiklandi(e));
      document.addEventListener('kuk:sepete-eklendi', (e) => this.urunEklendi(e));
      // Sayfadaki hızlı ekleme butonları (kampanya set kartı): ekleyip çekmeceyi açar; JS yoksa form /cart/add'e gider
      if (this.cekmece) document.addEventListener('click', (e) => {
        const dugme = e.target.closest('[data-kuk-sepete-ekle]');
        if (dugme && !this.contains(dugme)) { e.preventDefault(); this.disaridanEkle(dugme); }
      });
      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        this.gonderiliyor = false;
        this.querySelector('[data-odemeye-gec]')?.classList.remove('is-yukleniyor');
        this.yenidenCiz();
      });
      if (this.panel) {
        this.panel.addEventListener('cancel', (e) => { e.preventDefault(); this.kapat(); });
        this.panel.addEventListener('click', (e) => { if (e.target === this.panel) this.kapat(); });
        window.addEventListener('popstate', () => {
          if (this.panel.open && !(window.history.state && window.history.state.kukSepet)) this.kapat({ gecmis: false });
        });
      }
      this.notSayaci();
      this.denetle();
    }

    /* Açma ve kapatma (çekmece) */
    ikonaTiklandi(e) {
      const ikon = e.target.closest('#cart-icon-bubble');
      if (!ikon || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      if (!this.cekmece) { window.scrollTo({ top: 0, behavior: kaydirma() }); return; }
      // Menü açıkken başlık menüyü kapatıp geçmişte geri gider; çekmece o adımdan sonra açılır
      if (document.querySelector('kuk-baslik')?.gecmisBekliyor) window.addEventListener('popstate', () => this.ac(), { once: true });
      else this.ac();
    }

    ac() {
      if (!this.panel || this.panel.open) return;
      this.oncekiOdak = document.activeElement;
      this.panel.showModal();
      kilit.ac();
      window.history.pushState({ ...(window.history.state || {}), kukSepet: true }, '');
      if (this.govde) this.govde.scrollTop = 0;
      this.querySelector('#KukSepetBaslik')?.focus({ preventScroll: true });
      if (azHareket()) this.panel.classList.add('is-acik');
      else requestAnimationFrame(() => requestAnimationFrame(() => this.panel.classList.add('is-acik')));
      window.kukKargoGunu?.yaz();
    }

    kapat({ gecmis = true } = {}) {
      if (!this.panel || !this.panel.open || this.kapaniyor) return;
      this.kapaniyor = true;
      this.panel.classList.remove('is-acik');
      this.eklendiKaldir(true);
      const bitir = () => {
        this.panel.close();
        kilit.kapat();
        this.kapaniyor = false;
        if (this.oncekiOdak && document.contains(this.oncekiOdak)) this.oncekiOdak.focus({ preventScroll: true });
      };
      if (azHareket()) bitir(); else setTimeout(bitir, 200);
      if (gecmis && window.history.state && window.history.state.kukSepet) window.history.back();
    }

    // Çekmeceden başka sayfaya giderken önce çekmecenin geçmiş kaydı silinir (geri tuşu iki kez gerekmesin)
    sayfayaGit(e, baglanti) {
      if (!this.cekmece || !this.panel?.open || e.metaKey || e.ctrlKey || e.shiftKey || baglanti.target === '_blank') return;
      if (!(window.history.state && window.history.state.kukSepet)) return;
      e.preventDefault();
      let gitti = false;
      const git = () => { if (!gitti) { gitti = true; window.location.href = baglanti.href; } };
      window.addEventListener('popstate', git, { once: true });
      setTimeout(git, 400);
      window.history.back();
    }

    /* Ürün sayfasından ekleme: çekmece yanıttaki bölümle çizilir ve açılır */
    urunEklendi(e) {
      if (!this.cekmece || !this.panel) return;
      e.preventDefault();
      const veri = e.detail || {};
      const anahtarlar = (veri.items || [veri]).map((i) => i && i.key).filter(Boolean);
      const bolumler = veri.sections || {};
      if (bolumler[this.dataset.bolum]) this.ciz(bolumler, { sayac: false });
      this.ac();
      this.yeniVurgula(anahtarlar);
      this.eklendiGoster(this.dataset.metinEklendi);
      if (!bolumler[this.dataset.bolum]) this.yenidenCiz().then(() => this.yeniVurgula(anahtarlar));
    }

    /* Tıklamalar (olay devri) */
    tikla(e) {
      const t = e.target;
      const adet = t.closest('[data-sepet-adet]');
      if (adet) {
        const satir = adet.closest('[data-anahtar]');
        const yeni = Number(satir.dataset.adet) + Number(adet.dataset.sepetAdet);
        if (yeni <= 0) this.sil(satir); else this.adetDegistir(satir, yeni);
        return;
      }
      const sil = t.closest('[data-sepet-sil]');
      if (sil) { this.sil(sil.closest('[data-anahtar]')); return; }
      const hizli = t.closest('[data-hizli-ekle]');
      if (hizli) { this.hizliEkle(hizli); return; }
      if (t.closest('[data-geri-al]')) { this.geriAl(); return; }
      if (t.closest('[data-sepet-kapat]')) { e.preventDefault(); this.kapat(); return; }
      const politika = t.closest('a[data-politika]');
      if (politika) { e.preventDefault(); this.politikaAc(politika); return; }
      const ozet = t.closest('details[data-katli] > summary');
      if (ozet) { this.katliAc(e, ozet.parentElement); return; }
      const baglanti = t.closest('a[href]');
      if (baglanti) this.sayfayaGit(e, baglanti);
    }

    // Hediye notu açılırken klavye aynı dokunuşta gelsin diye alan tıklama içinde odaklanır (iOS)
    katliAc(e, katli) {
      if (katli.open || katli.dataset.katli !== 'hediye') return;
      e.preventDefault();
      katli.open = true;
      const alan = katli.querySelector('textarea');
      if (!alan) return;
      alan.focus({ preventScroll: true });
      setTimeout(() => alan.scrollIntoView({ block: 'nearest', behavior: kaydirma() }), azHareket() ? 0 : 220);
    }

    /* Sepet istekleri: yanıtla birlikte sepet bölümü ve başlık sayacı gelir */
    async istek(rota, govde) {
      const zamanAsimi = new AbortController();
      const sayac = setTimeout(() => zamanAsimi.abort(), 15000);
      try {
        const yanit = await fetch(`${window.routes[rota]}.js`, {
          method: 'POST',
          headers: BASLIK,
          body: JSON.stringify({ ...govde, sections: [this.dataset.bolum, 'cart-icon-bubble'], sections_url: window.location.pathname }),
          signal: zamanAsimi.signal,
        });
        const veri = await yanit.json().catch(() => ({}));
        if (!yanit.ok) throw Object.assign(new Error('sepet'), { durum: yanit.status, veri });
        return veri;
      } finally {
        clearTimeout(sayac);
      }
    }

    async yenidenCiz() {
      try {
        const yanit = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(this.dataset.bolum)},cart-icon-bubble`);
        if (yanit.ok) this.ciz(await yanit.json(), { sayac: true });
      } catch (hata) { /* eski hali kalır */ }
    }

    // Yalnız data-sepet-parca alanları değişir; yazılan notlar, açık katlı satırlar ve odak korunur
    ciz(bolumler, { sayac = true, zipla = false } = {}) {
      const html = bolumler && bolumler[this.dataset.bolum];
      if (html) {
        const yeni = new DOMParser().parseFromString(html, 'text/html');
        const durum = this.durumAl();
        this.querySelectorAll('[data-sepet-parca]').forEach((eski) => {
          const kaynak = yeni.querySelector(`[data-sepet-parca="${eski.dataset.sepetParca}"]`);
          if (kaynak) eski.innerHTML = kaynak.innerHTML;
        });
        this.durumYaz(durum);
        window.kukKargoGunu?.yaz();
      }
      const kabarcik = sayac && bolumler && bolumler['cart-icon-bubble'];
      const hedef = document.getElementById('cart-icon-bubble');
      if (kabarcik && hedef) {
        const ic = new DOMParser().parseFromString(kabarcik, 'text/html').querySelector('.shopify-section');
        if (ic) {
          if (!zipla) ic.querySelectorAll('.is-zipla').forEach((s) => s.classList.remove('is-zipla'));
          hedef.innerHTML = ic.innerHTML;
        }
      }
      this.denetle();
    }

    // Odak kaydı: butonlar pasifleşince odak düşer, bu yüzden meşgul olmadan önce de alınır (mesgulAc)
    odakAl() {
      const odak = document.activeElement;
      if (!odak || !this.contains(odak)) return null;
      const satir = odak.closest('[data-anahtar]');
      if (!satir) return odak.id ? { id: odak.id } : { baslik: true };
      const dugme = odak.matches('[data-sepet-sil]') ? '[data-sepet-sil]' : odak.dataset.sepetAdet ? `[data-sepet-adet="${odak.dataset.sepetAdet}"]` : null;
      return { satir: satir.dataset.anahtar, dugme };
    }

    durumAl() {
      const alanlar = {};
      this.querySelectorAll('[data-sepet-ozellik]').forEach((a) => { alanlar[a.dataset.sepetOzellik] = a.value; });
      return {
        alanlar,
        acik: [...this.querySelectorAll('details[data-katli]')].filter((d) => d.open).map((d) => d.dataset.katli),
        kurumsal: this.querySelector('[data-kurumsal-kutu]')?.checked,
        sozlesme: this.querySelector('[data-sozlesme]')?.checked,
        odak: this.odakAl() || this.odakKaydi || null,
      };
    }

    durumYaz(d) {
      this.querySelectorAll('[data-sepet-ozellik]').forEach((a) => {
        if (Object.prototype.hasOwnProperty.call(d.alanlar, a.dataset.sepetOzellik)) a.value = d.alanlar[a.dataset.sepetOzellik];
      });
      this.querySelectorAll('details[data-katli]').forEach((k) => { if (d.acik.includes(k.dataset.katli)) k.open = true; });
      const kurumsal = this.querySelector('[data-kurumsal-kutu]');
      if (kurumsal && d.kurumsal !== undefined) { kurumsal.checked = d.kurumsal; this.kurumsalGoster(d.kurumsal, false); }
      const sozlesme = this.querySelector('[data-sozlesme]');
      if (sozlesme && d.sozlesme !== undefined) sozlesme.checked = d.sozlesme;
      this.notSayaci();
      const o = d.odak;
      let hedef = o && o.id ? document.getElementById(o.id) : null;
      if (!hedef && o && o.satir) {
        const satir = this.querySelector(secici(o.satir));
        hedef = satir && o.dugme ? satir.querySelector(o.dugme) : null;
        if (!hedef || hedef.disabled) hedef = this.querySelector('#KukSepetBaslik') || this.querySelector('h1');
      }
      // Odak yeniden çizilen bir öğedeydi (ör. şeritten çıkan kart): başlığa gider
      if (!hedef && o && o.baslik && !this.contains(document.activeElement)) hedef = this.querySelector('#KukSepetBaslik') || this.querySelector('h1');
      if (hedef) {
        if (!hedef.hasAttribute('tabindex') && hedef.matches('h1')) hedef.setAttribute('tabindex', '-1');
        hedef.focus({ preventScroll: true });
      }
    }

    /* Meşgul hali: satırın sayısı yerine dönen gösterge, satır butonları ve ÖDEMEYE GEÇ pasif */
    mesgulAc(satir) {
      this.mesgul = true;
      this.odakKaydi = this.odakAl();
      if (satir) {
        satir.classList.add('is-mesgul');
        satir.querySelectorAll('button').forEach((b) => { b.dataset.oncekiPasif = b.disabled ? '1' : ''; b.disabled = true; });
        const hata = satir.querySelector('[data-satir-hata]');
        if (hata) hata.hidden = true;
      }
      this.denetle();
    }

    mesgulKapat() {
      this.mesgul = false;
      this.odakKaydi = null;
      this.querySelectorAll('.kuk-sepet-satir.is-mesgul').forEach((s) => {
        s.classList.remove('is-mesgul');
        s.querySelectorAll('button').forEach((b) => { b.disabled = b.dataset.oncekiPasif === '1'; delete b.dataset.oncekiPasif; });
      });
      this.denetle();
    }

    satirHatasi(anahtar, metin) {
      const hata = this.querySelector(secici(anahtar))?.querySelector('[data-satir-hata]');
      if (!hata) return;
      hata.textContent = metin;
      hata.hidden = false;
    }

    /* 6. Adet: change.js istenen adedi stokla sınırlar; sınır aşılırsa adet stoğa çekilir */
    async adetDegistir(satir, yeni) {
      if (this.mesgul || !satir) return;
      const anahtar = satir.dataset.anahtar;
      const sinir = satir.dataset.sinir;
      this.mesgulAc(satir);
      try {
        const veri = await this.istek('cart_change_url', { id: anahtar, quantity: yeni });
        this.ciz(veri.sections);
        const son = (veri.items || []).find((i) => i.key === anahtar);
        if (son && son.quantity < yeni) this.satirHatasi(anahtar, doldur(this.dataset.metinStok, { adet: son.quantity }));
      } catch (hata) {
        if (hata.durum === 422 && sinir !== '' && Number(sinir) > 0) {
          try {
            const veri = await this.istek('cart_change_url', { id: anahtar, quantity: Number(sinir) });
            this.ciz(veri.sections);
          } catch (hata2) { /* eski adet kalır */ }
          this.satirHatasi(anahtar, doldur(this.dataset.metinStok, { adet: sinir }));
        } else {
          this.satirHatasi(anahtar, this.dataset.metinGuncellenemedi);
        }
      } finally {
        this.mesgulKapat();
      }
    }

    /* 6. Sil: satır 200 ms'de solar, 5 sn 'Ürün çıkarıldı. Geri al'; onay sorulmaz */
    async sil(satir) {
      if (this.mesgul || !satir) return;
      let ozellikler = {};
      try { ozellikler = JSON.parse(satir.dataset.ozellikler || '{}') || {}; } catch (hata) { ozellikler = {}; }
      const kayit = { id: Number(satir.dataset.varyant), quantity: Number(satir.dataset.adet), properties: ozellikler };
      this.mesgulAc(satir);
      satir.classList.add('is-siliniyor');
      try {
        const [veri] = await Promise.all([this.istek('cart_change_url', { id: satir.dataset.anahtar, quantity: 0 }), bekle(azHareket() ? 0 : 200)]);
        this.ciz(veri.sections);
        this.geriAlGoster(kayit);
        olay('remove_from_cart', { varyant: kayit.id, adet: kayit.quantity, kaynak: this.dataset.baglam });
      } catch (hata) {
        satir.classList.remove('is-siliniyor');
        this.satirHatasi(satir.dataset.anahtar, this.dataset.metinGuncellenemedi);
      } finally {
        this.mesgulKapat();
      }
    }

    geriAlGoster(kayit) {
      const bildirim = this.querySelector('[data-sepet-geri-al]');
      if (!bildirim) return;
      this.silinen = kayit;
      bildirim.hidden = false;
      clearTimeout(this.geriAlSayac);
      this.geriAlSayac = setTimeout(() => { bildirim.hidden = true; this.silinen = null; }, 5000);
    }

    async geriAl() {
      const kayit = this.silinen;
      if (!kayit || this.mesgul) return;
      this.silinen = null;
      clearTimeout(this.geriAlSayac);
      const bildirim = this.querySelector('[data-sepet-geri-al]');
      if (bildirim) bildirim.hidden = true;
      this.mesgulAc(null);
      try {
        const veri = await this.istek('cart_add_url', { items: [kayit] });
        this.ciz(veri.sections, { zipla: true });
        this.yeniVurgula((veri.items || []).map((i) => i.key));
      } catch (hata) {
        this.geriAlGoster(kayit);
      } finally {
        this.mesgulKapat();
      }
    }

    /* 8. Hızlı ekle: seçim sorulmaz; buton 600 ms tik, yeni satır üstte, kart şeritten çıkar */
    async hizliEkle(dugme) {
      if (this.mesgul) return;
      const oge = dugme.closest('li');
      oge?.querySelector('.kuk-sepet-oneri__hata')?.remove();
      const id = Number(dugme.dataset.hizliEkle);
      this.mesgulAc(null);
      dugme.classList.add('is-yukleniyor');
      try {
        const veri = await this.istek('cart_add_url', { items: [{ id, quantity: 1 }] });
        dugme.classList.remove('is-yukleniyor');
        dugme.classList.add('is-eklendi');
        olay('add_to_cart', { varyant: id, adet: 1, kaynak: 'sepet' });
        await bekle(600);
        this.ciz(veri.sections, { zipla: true });
        this.yeniVurgula((veri.items || []).map((i) => i.key));
        this.eklendiGoster(doldur(this.dataset.metinEklendiAd, { ad: dugme.dataset.ad || '' }));
      } catch (hata) {
        dugme.classList.remove('is-yukleniyor');
        if (oge) {
          const uyari = document.createElement('p');
          uyari.className = 'kuk-sepet-oneri__hata';
          uyari.setAttribute('role', 'alert');
          uyari.textContent = this.dataset.metinEklenemedi;
          oge.prepend(uyari);
        }
      } finally {
        this.mesgulKapat();
      }
    }

    async disaridanEkle(dugme) {
      if (dugme.classList.contains('is-yukleniyor')) return;
      const id = Number(dugme.dataset.kukSepeteEkle);
      const hata = dugme.parentElement.querySelector('[data-ekle-hata]');
      if (hata) hata.hidden = true;
      dugme.classList.add('is-yukleniyor');
      try {
        const veri = await this.istek('cart_add_url', { items: [{ id, quantity: 1 }] });
        olay('add_to_cart', { varyant: id, adet: 1, kaynak: dugme.dataset.kaynak || 'sayfa' });
        this.ciz(veri.sections, { zipla: true });
        this.ac();
        this.yeniVurgula((veri.items || []).map((i) => i.key));
        this.eklendiGoster(this.dataset.metinEklendi);
      } catch (h) {
        if (hata) hata.hidden = false;
      } finally {
        dugme.classList.remove('is-yukleniyor');
      }
    }

    yeniVurgula(anahtarlar) {
      if (azHareket()) return;
      anahtarlar.forEach((k) => {
        const satir = this.querySelector(secici(k));
        if (!satir) return;
        satir.classList.remove('is-yeni');
        void satir.offsetWidth;
        satir.classList.add('is-yeni');
      });
    }

    /* 4. 'Sepete eklendi' satırı: 4 sn sonra ya da gövde ilk kaydırıldığında kalkar */
    eklendiGoster(metin) {
      const satir = this.querySelector('[data-sepet-eklendi]');
      if (!satir) return;
      satir.querySelector('[data-sepet-eklendi-metin]').textContent = metin;
      satir.classList.add('is-gorunur');
      this.eklendiZamani = performance.now();
      clearTimeout(this.eklendiSayac);
      this.eklendiSayac = setTimeout(() => this.eklendiKaldir(true), 4000);
    }

    eklendiKaldir(zorla) {
      const satir = this.querySelector('[data-sepet-eklendi]');
      if (!satir || !satir.classList.contains('is-gorunur')) return;
      if (!zorla && performance.now() - this.eklendiZamani < 400) return;
      clearTimeout(this.eklendiSayac);
      satir.classList.remove('is-gorunur');
      setTimeout(() => {
        if (!satir.classList.contains('is-gorunur')) satir.querySelector('[data-sepet-eklendi-metin]').textContent = '';
      }, 250);
    }

    /* 7 ve 9. Sepet özellikleri: yazdıktan 500 ms sonra kaydedilir */
    girdi(e) {
      const alan = e.target.closest('[data-sepet-ozellik]');
      if (!alan) return;
      if (alan.matches('[data-vkn]')) {
        const temiz = alan.value.replace(/\D/g, '').slice(0, 10);
        if (temiz !== alan.value) alan.value = temiz;
        this.vknHata(false);
      }
      if (alan.matches('textarea')) this.notSayaci();
      alan.classList.remove('is-hatali');
      this.ozellikKaydet(alan.dataset.sepetOzellik, alan.value);
      this.denetle();
    }

    degisti(e) {
      const t = e.target;
      if (t.matches('[data-kurumsal-kutu]')) this.kurumsalGoster(t.checked, true);
      else if (t.matches('[data-sozlesme]')) { if (t.checked) this.sozlesmeHata(false); this.denetle(); }
      else if (t.matches('[data-vkn]')) this.vknHata(t.value !== '' && !this.vknGecerli());
    }

    ozellikKaydet(ad, deger) {
      clearTimeout(this.kayitlar[ad]);
      this.kayitlar[ad] = setTimeout(() => this.ozellikleriYaz({ [ad]: String(deger).trim() }), 500);
    }

    async ozellikleriYaz(ozellikler) {
      try {
        await fetch(`${window.routes.cart_update_url}.js`, { method: 'POST', headers: BASLIK, body: JSON.stringify({ attributes: ozellikler }), keepalive: true });
      } catch (hata) { /* ödemeye geçerken form da gönderir */ }
    }

    notSayaci() {
      const alan = this.querySelector('textarea[data-sepet-ozellik]');
      if (!alan) return;
      const sayac = this.querySelector('[data-not-sayac]');
      if (sayac) sayac.textContent = `${alan.value.length}/200`;
      const uyari = this.querySelector('[data-not-uyari]');
      if (uyari) uyari.hidden = !emoji.test(alan.value);
    }

    // Kutu kaldırılınca üç alan da boşaltılır ve özellikler silinir
    kurumsalGoster(acik, kaydet) {
      const kok = this.querySelector('[data-kurumsal]');
      if (!kok) return;
      const alanlar = kok.querySelector('[data-kurumsal-alanlar]');
      kok.classList.toggle('is-acik', acik);
      alanlar.hidden = !acik;
      kok.querySelector('[data-kurumsal-tip]').value = acik ? 'Kurumsal' : '';
      alanlar.querySelectorAll('input').forEach((i) => {
        i.required = acik;
        if (!acik && kaydet) { i.value = ''; i.classList.remove('is-hatali'); }
      });
      if (!acik) this.vknHata(false);
      if (kaydet) {
        Object.values(this.kayitlar).forEach(clearTimeout);
        const ozellikler = {};
        kok.querySelectorAll('[data-sepet-ozellik]').forEach((i) => { ozellikler[i.dataset.sepetOzellik] = i.value.trim(); });
        this.ozellikleriYaz(ozellikler);
      }
      this.denetle();
    }

    vknGecerli() {
      const kutu = this.querySelector('[data-kurumsal-kutu]');
      if (!kutu || !kutu.checked) return true;
      const vkn = this.querySelector('[data-vkn]');
      return !!vkn && /^\d{10}$/.test(vkn.value.trim());
    }

    vknHata(acik) {
      const hata = this.querySelector('[data-vkn-hata]');
      if (hata) hata.hidden = !acik;
      this.querySelector('[data-vkn]')?.classList.toggle('is-hatali', acik);
    }

    sozlesmeHata(acik) {
      const hata = this.querySelector('[data-sozlesme-hata]');
      if (hata) hata.hidden = !acik;
      this.querySelector('[data-sozlesme-satir]')?.classList.toggle('is-hatali', acik);
    }

    // ÖDEMEYE GEÇ: güncelleme sürerken gerçekten pasif; onay ya da VKN eksikse pasif görünür ama dokununca hata yazar
    denetle() {
      const dugme = this.querySelector('[data-odemeye-gec]');
      if (!dugme) return;
      const sozlesme = this.querySelector('[data-sozlesme]');
      dugme.classList.toggle('is-pasif', (sozlesme && !sozlesme.checked) || !this.vknGecerli());
      dugme.disabled = !!this.mesgul;
    }

    /* 11. ÖDEMEYE GEÇ: form /cart'a gider (özellikler kaydolur), Shopify doğrudan ödeme sayfasına yönlendirir */
    gonder(e) {
      if (this.mesgul || this.gonderiliyor) { e.preventDefault(); return; }
      const sozlesme = this.querySelector('[data-sozlesme]');
      if (sozlesme && !sozlesme.checked) {
        e.preventDefault();
        this.sozlesmeHata(true);
        sozlesme.focus();
        return;
      }
      const kutu = this.querySelector('[data-kurumsal-kutu]');
      if (kutu && kutu.checked) {
        const eksik = [...this.querySelectorAll('[data-kurumsal-alanlar] input')].filter((i) => !i.value.trim() || (i.matches('[data-vkn]') && !this.vknGecerli()));
        if (eksik.length) {
          e.preventDefault();
          eksik.forEach((i) => i.classList.add('is-hatali'));
          if (!this.vknGecerli()) this.vknHata(true);
          eksik[0].focus({ preventScroll: true });
          eksik[0].scrollIntoView({ block: 'center', behavior: kaydirma() });
          return;
        }
      }
      if (sozlesme) sozlesme.value = `evet, ${new Date().toISOString()}`;
      Object.values(this.kayitlar).forEach(clearTimeout);
      this.gonderiliyor = true;
      this.querySelector('[data-odemeye-gec]')?.classList.add('is-yukleniyor');
      const toplam = this.querySelector('[data-sepet-toplam]');
      olay('begin_checkout', { tutar: Number(toplam?.dataset.kurus || 0), kaynak: this.dataset.baglam });
    }

    // Klavye açıkken (gövdedeki yazı alanları) alt blok gizlenir
    klavye(e, acik) {
      if (!dokunmatik() || !this.govde) return;
      const alan = e.target.closest('textarea, input[type="text"], input:not([type])');
      if (!alan || !this.govde.contains(alan)) return;
      clearTimeout(this.klavyeSayac);
      if (acik) this.classList.add('is-klavye');
      else this.klavyeSayac = setTimeout(() => this.classList.remove('is-klavye'), 150);
    }

    /* 12. Politika alt sayfası: metin politika sayfasından okunur; okunamazsa sayfa bağlantısı */
    async politikaAc(baglanti) {
      const dialog = this.querySelector('[data-sepet-politika]');
      if (!dialog) { window.location.href = baglanti.href; return; }
      const metin = dialog.querySelector('[data-politika-metin]');
      dialog.querySelector('[data-politika-baslik]').textContent = baglanti.textContent.trim();
      metin.textContent = '';
      metin.setAttribute('aria-busy', 'true');
      altSayfa.ac(dialog);
      try {
        const yanit = await fetch(baglanti.href, { headers: { Accept: 'text/html' } });
        if (!yanit.ok) throw new Error('politika');
        const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');
        const govde = belge.querySelector('.shopify-policy__body') || belge.querySelector('#MainContent .rte');
        if (!govde || !govde.textContent.trim()) throw new Error('politika');
        // 'Bölüme atla' sayfanın kendi kaydırmasına göre; alt sayfada gereksiz
        govde.querySelectorAll('.kuk-bolume-atla').forEach((d) => d.remove());
        metin.innerHTML = govde.innerHTML;
      } catch (hata) {
        const p = document.createElement('p');
        p.textContent = `${this.dataset.metinPolitikaYok} `;
        const a = document.createElement('a');
        a.href = baglanti.href;
        a.textContent = this.dataset.metinPolitikaSayfa;
        p.append(a);
        metin.replaceChildren(p);
      } finally {
        metin.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('kuk-sepet', KukSepet);

  /* Shopify Standard Actions (window.Shopify.actions; vitrin işleyicisi enjekte eder): bir uygulama ya da Shopify
     özelliği sepeti açtığında Kuk çekmecesi açılır, sepeti güncellediğinde çekmece ve başlık sayacı yeniden çizilir.
     Dawn'ın standard-actions-override.js dosyasının Kuk karşılığı. */
  const eylemleriKur = () => {
    const eylemler = window.Shopify && window.Shopify.actions;
    if (!eylemler) return;
    const sepet = () => document.querySelector('kuk-sepet[data-baglam="cekmece"]') || document.querySelector('kuk-sepet');
    eylemler.openCart?.configure({
      async handler(varsayilan) {
        const c = document.querySelector('kuk-sepet[data-baglam="cekmece"]');
        if (c && typeof c.ac === 'function') { c.ac(); return undefined; }
        return varsayilan();
      },
    });
    eylemler.updateCart?.configure({
      eventTarget: () => document,
      async handler(varsayilan) {
        const sonuc = await varsayilan();
        try { await sepet()?.yenidenCiz(); } catch (hata) { window.location.reload(); }
        return sonuc;
      },
    });
  };
  if (window.Shopify && window.Shopify.actions) eylemleriKur();
  else document.addEventListener('DOMContentLoaded', eylemleriKur, { once: true });
})();
